import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import './FacetPanelLoading.scss';

class FacetPanelLoading extends Component {
  static propTypes = {
    numberOfFacets: PropTypes.number,
    numberOfSubItems: PropTypes.number,
    includeHeader: PropTypes.bool,
    className: PropTypes.string
  };

  render() {
    const { numberOfFacets, includeHeader, className, numberOfSubItems } = this.props;
    let rowRender = [],
      subItemsRender = [],
      iterationCount = numberOfFacets,
      subItemIterationCount = numberOfSubItems;
    if (includeHeader) rowRender.push(<div key={'loading-facet-header'} className="loading-facet__header pulse"></div>);
    while (subItemIterationCount--)
      subItemsRender.push(
        <div key={'subitem-' + subItemIterationCount} className="loading-facet__empty-subitem pulse"></div>
      );
    while (iterationCount--)
      rowRender.push(
        <div className="loading-facet__empty" key={'loading-facet-' + iterationCount}>
          <div className="loading-facet__empty-header pulse"></div>
          {subItemsRender}
        </div>
      );
    return <div className={classnames('facet__panel-container loading-facet__container', className)}>{rowRender}</div>;
  }
}

export default FacetPanelLoading;
